import { HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { Router } from "@angular/router";
import { AppService } from "src/app/app.service";
import { environment } from "src/environments/environment";
import { isPlatformBrowser, isPlatformServer } from '@angular/common';



@Injectable({
    providedIn: "root"
})
export class AppInterceptor implements HttpInterceptor {

    // UserData: any = JSON.parse(localStorage.getItem("UserData"));

    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        private app: AppService,
        private router: Router
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): any {

        let langServerSideCode = this?.router?.url?.includes('/ar/') ? 'ar' : 'en';
        const LangCode = isPlatformBrowser(this.platformId) ? this?.app?.languageCode : langServerSideCode

        if (isPlatformBrowser(this.platformId)) {
            if (request.url.includes(environment.baseUrl)) {
                const clonedRequest = request.clone({
                    headers: new HttpHeaders({
                        "Authorization": `Bearer ${localStorage?.getItem(environment?.appName)}`,
                        'Access-Control-Allow-Origin': '*',
                        'Accept-language': LangCode,
                        'No-Auth': 'True',
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        'Pragma': 'no-cache',
                        'Expires': '0'
                    })
                });
                return next.handle(clonedRequest)
            } else {
                const clonedRequest = request.clone({
                    headers: new HttpHeaders({
                        'Accept-Language': 'en-us',
                    })
                });
                return next.handle(clonedRequest);
            }
            // console.warn("Browser",clonedRequest)

        } else if (isPlatformServer(this.platformId)) {
            const clonedRequest = request.clone({
                headers: new HttpHeaders({
                    'Access-Control-Allow-Origin': '*',
                    'No-Auth': 'True',
                    'Accept-language': LangCode,
                })
            });
            return next.handle(clonedRequest)
        }
    }
}